export default __webpack_public_path__ + "static/media/img-level-info-desktop.e210244d.png";